/*
 * @fileOverView Hero Podcast component definition
 */

import Vue from 'vue';
import Analytics from 'mixins/analytics.mixin';

/**
 * Hero Podcast component
 *
 * @type {class}
 */
Vue.component('hero-podcast-vue', {
  mixins:[
    Analytics
  ],

  props: {
    'podcastName': String
  },

  mounted() {
    const audioPlayer = this.$el.querySelector('.audio');

    if (audioPlayer) {
      audioPlayer.addEventListener('play', this.handleAudioPlay);
    }
  },

  methods: {
    handleAudioPlay(e) {
      this.pushPodcastStartedEvent(this.podcastName);
    },

    handleDropdownChanged(selectedIndex, selected, element) {
      const medium = selected.replace('Listen on ', '');

      this.pushPodcastSubscriptionClickedEvent(this.podcastName, medium);
    }
  }
});
